const mainConfig = {
  cookiesDays: 365,
  api: "http://localhost:5000",
  amo: "https://dev-trade.rspp-centre.com/signup?type=1",
  recaptchaClientKey: "6LfijvMZAAAAAI8bC2VNC-kBnSu-LpFm76ti7a-R",
  cookiesDomain: "localhost"
};

export default mainConfig;
